export default __webpack_public_path__ + "static/5-small-9fe6d8ca2beb33f6d04f3063ad2c4dee.jpg";